// extracted by mini-css-extract-plugin
export default {"cardHeader":"cardHeader---nY3Mu","dropzone":"dropzone---HBb0O"};